import { fromJS } from "immutable";
import { cancelReservation, putReservation } from "../../utils/witbookingApi";
import { name } from "./__init__";
import { Configurer } from "../App";
import { actions as appActions } from "../App";

export const initialState = fromJS({
  ticker: null,
  cancelLoaded: false,
  cancelLoading: false,
  cancelError: false,
  loading: false,
  generalLoading: false,
  accommodationARI: undefined,
  reservationARI: undefined,
  modificationSuccess: undefined,
  error: false,
  accommodation: undefined,
  checkIn: undefined,
  checkOut: undefined,
  inventory: undefined,
  numberOfUnits: undefined,
  extrasQuantity: undefined,
  extrasForm: undefined,
});

const CANCEL_RESERVATION = `${name}/CANCEL_RESERVATION`;
const CANCEL_RESERVATION_SUCCESS = `${name}/CANCEL_RESERVATION_SUCCESS`;
const CANCEL_RESERVATION_ERROR = `${name}/CANCEL_RESERVATION_ERROR`;
const LOADING = `${name}/LOADING`;
const GENERAL_LOADING = `${name}/GENERAL_LOADING`;
const REQUEST_ARI_SUCCESS = `${name}/REQUEST_ARI_SUCCESS`;
const REQUEST_ARI_ERROR = `${name}/REQUEST_ARI_ERROR`;
const REQUEST_RESERVATION_ARI_SUCCESS = `${name}/REQUEST_RESERVATION_ARI_SUCCESS`;
const REQUEST_RESERVATION_ARI_ERROR = `${name}/REQUEST_RESERVATION_ARI_ERROR`;
const MODIFICATION_SUCCESS = `${name}/MODIFICATION_SUCCESS`;
const MODIFICATION_ERROR = `${name}/MODIFICATION_ERROR`;
const RESET = `${name}/RESET`;
const SELECT_ACCOMMODATION = `${name}/SELECT_ACCOMMODATION`;
const SELECT_PACKAGE = `${name}/SELECT_PACKAGE`;
const SELECT_DATES = `${name}/SELECT_DATES`;
const SELECT_INVENTORY = `${name}/SELECT_INVENTORY`;
const SELECT_EXTRAS = `${name}/SELECT_EXTRAS`;

export function resetState() {
  return {
    type: RESET,
  };
}

export function selectInventory({ inventory, numberOfUnits }) {
  return {
    type: SELECT_INVENTORY,
    inventory,
    numberOfUnits,
  };
}

export function selectDates({ checkIn, checkOut }) {
  return {
    type: SELECT_DATES,
    checkIn,
    checkOut,
  };
}

export function selectAccommodation(accommodation) {
  return {
    type: SELECT_ACCOMMODATION,
    accommodation,
  };
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CANCEL_RESERVATION_SUCCESS:
      return state.set("cancelLoading", false).set("cancelLoaded", true).set("cancelError", false);
    case CANCEL_RESERVATION_ERROR:
      return state.set("cancelLoading", false).set("cancelLoaded", true).set("cancelError", true);
    case CANCEL_RESERVATION:
      return state.set("cancelLoaded", false).set("cancelLoading", true).set("cancelError", false);
    case GENERAL_LOADING:
      return state.set("generalLoading", true);
    case LOADING:
      return state.set("loading", true);
    case REQUEST_ARI_SUCCESS:
      return state.set("accommodationARI", fromJS(action.result.data)).set("loading", false);
    case REQUEST_ARI_ERROR:
      return state.set("error", action.error).set("loading", false);
    case REQUEST_RESERVATION_ARI_SUCCESS:
      return state.set("reservationARI", fromJS(action.result.data)).set("globalLoading", false);
    case REQUEST_RESERVATION_ARI_ERROR:
      return state.set("error", action.error).set("globalLoading", false);
    case MODIFICATION_SUCCESS:
      return state.set("modificationSuccess", true).set("loading", false);
    case MODIFICATION_ERROR:
      return state.set("modificationSuccess", false).set("loading", false);
    case RESET:
      return state
        .set("loading", false)
        .set("accommodationARI", undefined)
        .set("modificationSuccess", undefined)
        .set("accommodation", undefined)
        .set("checkIn", undefined)
        .set("checkOut", undefined)
        .set("inventory", undefined)
        .set("numberOfUnits", undefined);
    case SELECT_ACCOMMODATION:
      return state.set("accommodation", action.accommodation);
    case SELECT_PACKAGE:
      return state.set("package", action.package);
    case SELECT_DATES:
      return state.set("checkIn", action.checkIn).set("checkOut", action.checkOut);
    case SELECT_INVENTORY:
      return state.set("inventory", action.inventory).set("numberOfUnits", action.numberOfUnits);
    case SELECT_EXTRAS:
      return state.set("extrasQuantity", action.quantity).set("extrasForms", action.forms);
    default:
      return state;
  }
};

export function cancelBook(params) {
  const reservationId = params.reservationId;
  const propertyTicker = params.hotelTicker;
  const cancellationReason = params.cancellationReason;
  return {
    types: [CANCEL_RESERVATION, CANCEL_RESERVATION_SUCCESS, CANCEL_RESERVATION_ERROR],
    promise: () => cancelReservation({}, { reservationId, propertyTicker, cancellationReason }),
  };
}

export function requestReservation({ reservationId, propertyTicker, locale }) {
  return dispatch => {
    return dispatch({
      types: [LOADING, MODIFICATION_SUCCESS, MODIFICATION_ERROR],
      promise: () => {
        return dispatch(
          appActions.requestReservationData({
            reservationId: reservationId,
            hotelTicker: propertyTicker,
            locale,
          })
        );
      },
    });
  };
}

export function requestReservationARI({
  propertyTicker,
  startDate,
  endDate,
  locale = "es",
  ignoredConfiguration = true,
  inventory,
  deviceInfo,
}) {
  return dispatch => {
    return dispatch({
      types: [GENERAL_LOADING, REQUEST_RESERVATION_ARI_SUCCESS, REQUEST_RESERVATION_ARI_ERROR],
      promise: () => {
        return Configurer.fetchARI(propertyTicker, {
          start: startDate,
          end: endDate,
          ignoredConfiguration,
          locale,
          inventoryTickersEqualFilter: [inventory],
          deviceInfo,
        }).then(data => {
          return { data };
        });
      },
    });
  };
}

export function requestModificationARI({
  propertyTicker,
  startDate,
  endDate,
  locale = "es",
  ignoredConfiguration = true,
  seniors = 0,
  adults = 2,
  teenagers = 0,
  children = 0,
  babies = 0,
  childrenCount = 0,
  guestAges = undefined,
  deviceInfo,
}) {
  return dispatch => {
    return dispatch({
      types: [LOADING, REQUEST_ARI_SUCCESS, REQUEST_ARI_ERROR],
      promise: () => {
        return Configurer.fetchARI(propertyTicker, {
          start: startDate,
          end: endDate,
          ignoredConfiguration,
          locale,
          seniors,
          adults,
          teenagers,
          children,
          babies,
          childrenCount,
          guestAges,
          deviceInfo,
        }).then(data => {
          return { data };
        });
      },
    });
  };
}

export function modifyReservation(reservationData, isUpdate = false) {
  return dispatch => {
    return dispatch({
      types: [LOADING, MODIFICATION_SUCCESS, MODIFICATION_ERROR],
      promise: () => {
        if (isUpdate) {
          return putReservation({}, { reservationData, method: "PUT" });
        }
        if (!isUpdate) {
          return postReservation({}, { reservationData, method: "PUT" })
            .then(({ resource }) => {
              return resource;
            })
            .catch(err => {
              console.log("ERROR");
              console.log(err);
            });
        }
      },
    });
  };
}

export function selectExtras({ quantity, forms }) {
  return {
    type: SELECT_EXTRAS,
    quantity,
    forms,
  };
}

export const actions = {
  CANCEL_RESERVATION,
  CANCEL_RESERVATION_SUCCESS,
  CANCEL_RESERVATION_ERROR,
  LOADING,
  MODIFICATION_SUCCESS,
  RESET,
  cancelBook,
  requestReservation,
  requestReservationARI,
  requestModificationARI,
  resetState,
  selectDates,
  modifyReservation,
  selectAccommodation,
  selectInventory,
  selectExtras,
};
